import { Box, Button, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '../../Icons/Close';
import { ArtProps } from '../../interfaces/components';
import { disptchCTAClickObject } from '../../Analytics';

const Art = ({ active, setActive, image, title, description }: ArtProps) => {
  const { t } = useTranslation();

  const onNFTClick = () => {
    const url = 'https://opensea.io/de-DE/collection/fidenza-village-streetart-festival';
    disptchCTAClickObject('fidenza', 'button', 'Art', 'See NFT Collection', url);
    window.open(url, '_blank');
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        width={['100vw', '100vw', '770px', '1000px']}
        height={['100%', '100%', '580px', '680px']}
        overflowY={['auto', 'auto', 'hidden']}
        // pb={['10', '10', '0']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '30px']}
          right={['30px', '30px', '30px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box
          display="flex"
          flexDirection={['column', 'column', 'row']}
          overflowX={['auto', 'auto', 'hidden']}
          pb={['10', '10', '0']}
        >
          <Image
            src={image}
            w={['100%', '100%', '300px', '480px']}
            h={['300px', '300px', '580px', '680px']}
            objectFit="cover"
            alt="cs"
          />
          <Box
            display="flex"
            flexDirection="column"
            mt={['10', '10', '0']}
            justifyContent="center"
            alignItems="center"
            w="100%"
          >
            <Text
              textAlign="center"
              fontWeight="400"
              fontFamily="SangBleuBPLight"
              fontSize={['24px', '24px', '32px', '40px', '40px']}
              maxW="80%"
              mx="auto"
              mb={['5', '5', '5', '8']}
            >
              {title}
            </Text>

            <Text
              textAlign="center"
              fontWeight="400"
              fontFamily="JosefinSans"
              className="copy"
              fontSize={['12px', '12px', '12px', '16px', '16px']}
              lineHeight={['18px', '18px', '18px', '20px', '20px']}
              whiteSpace="pre-line"
              maxW="80%"
            >
              {description}
            </Text>

            <Text
              mt="5"
              textAlign="center"
              fontWeight="400"
              fontFamily="SangBleuBPLight"
              fontSize={['16px', '16px', '18px', '20px', '20px']}
              maxW="80%"
              mx="auto"
              mb={['5', '5', '5', '5']}
            >
              {t('fv_art_nft_title')}
            </Text>

            <Text
              textAlign="center"
              fontWeight="400"
              fontFamily="JosefinSans"
              className="copy"
              fontSize={['12px', '12px', '12px', '16px', '16px']}
              lineHeight={['18px', '18px', '18px', '20px', '20px']}
              whiteSpace="pre-line"
              maxW="80%"
            >
              {t('fv_art_nft_description')}
            </Text>

            <Button
              bg="white"
              border="1px solid gray"
              borderRadius="0px"
              px="25px"
              h="46px"
              color="#455255"
              _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
              pt={['0', '0', '1']}
              mt="10"
              onClick={onNFTClick}
            >
              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                textTransform="uppercase"
                fontSize={['12px', '12px', '14px', '14px', '14px']}
              >
                {t('fv_art_nft_btn')}
              </Text>
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Art;
